// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmationModal_confirmation-modal__backdrop__pe3QY {
  background-color: rgba(30, 41, 59, 0.75) !important;
}
.ConfirmationModal_confirmation-modal__content__eUjSf {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  text-align: center;
  outline: none;
}
.ConfirmationModal_confirmation-modal__icon-wrapper__v5oG2 {
  width: 80px;
  height: 80px;
  background-color: #22c55e;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 0 0 8px rgba(255, 255, 255, 0.8);
  margin-bottom: 1.5rem;
}
.ConfirmationModal_confirmation-modal__icon__ZFRWF {
  color: #ffffff;
  font-size: 3rem !important;
}
.ConfirmationModal_confirmation-modal__title__NVZIK {
  font-size: 40px;
  font-weight: 500;
  color: #000000;
  margin: 0 0 0.5rem 0;
}
.ConfirmationModal_confirmation-modal__button__ZEIzk {
  background: #FE5F55;
  color: white;
  border: none;
  padding: 1.1rem 2.6rem;
  font-size: 0.9rem;
  font-weight: 400;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  margin-top: 2rem;
  width: 80%;
}
.ConfirmationModal_confirmation-modal__button__ZEIzk:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(63, 120, 176, 0.3);
}
.ConfirmationModal_confirmation-modal__button--primary__WIoNg {
  background-color: #FF6B6B;
  color: white;
}
.ConfirmationModal_confirmation-modal__button--primary__WIoNg:hover {
  background-color: #e65a5a;
}
@media (max-width: 767px) {
  .ConfirmationModal_confirmation-modal__content__eUjSf {
    width: 90%;
    max-width: 420px;
    padding: 3.5rem 1rem 2.5rem 1rem;
  }
  .ConfirmationModal_confirmation-modal__title__NVZIK {
    font-size: 28px;
  }
  .ConfirmationModal_confirmation-modal__subtitle__9TKML {
    font-size: 18px;
    color: #000000;
  }
  .ConfirmationModal_confirmation-modal__button__ZEIzk {
    width: 93%;
  }
  .ConfirmationModal_confirmation-modal__icon-wrapper__v5oG2 {
    width: 65px;
    height: 65px;
  }
}
.ConfirmationModal_confirmation-modal__error__iGOf9 {
  color: #d32f2f;
  font-size: 0.9rem;
  margin-top: 1rem;
  text-align: center;
}

.ConfirmationModal_confirmation-modal__eZdsE .ConfirmationModal_confirmation-modal__subtitle__9TKML {
  font-size: 24px;
  color: #000000;
  margin: 0 0 2rem 0;
  font-weight: 400;
  line-height: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/BookingPage/ConfirmationModal.module.scss"],"names":[],"mappings":"AAIE;EACE,mDAAA;AAHJ;AAME;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,qFAAA;EACA,kBAAA;EACA,aAAA;AAJJ;AAOE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,8CAAA;EACA,qBAAA;AALJ;AAQE;EACE,cAAA;EACA,0BAAA;AANJ;AASE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AAPJ;AAUE;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,gBAAA;EACA,UAAA;AARJ;AAUI;EACE,2BAAA;EACA,8CAAA;AARN;AAWI;EACE,yBAAA;EACA,YAAA;AATN;AAWM;EACE,yBAAA;AATR;AAcE;EACE;IACE,UAAA;IACA,gBAAA;IACA,gCAAA;EAZJ;EAeE;IACE,eAAA;EAbJ;EAgBE;IACE,eAAA;IACA,cAAA;EAdJ;EAiBE;IACE,UAAA;EAfJ;EAkBE;IACE,WAAA;IACA,YAAA;EAhBJ;AACF;AAoBE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAlBJ;;AAwBA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AArBF","sourcesContent":["$breakpoint-md: 767px;\n\n\n.confirmation-modal {\n  &__backdrop {\n    background-color: rgba(30, 41, 59, 0.75) !important;\n  }\n\n  &__content {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    text-align: center;\n    outline: none;\n  }\n\n  &__icon-wrapper {\n    width: 80px;\n    height: 80px;\n    background-color: #22c55e;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    box-shadow: 0 0 0 8px rgba(#ffffff, 0.8);\n    margin-bottom: 1.5rem;\n  }\n\n  &__icon {\n    color: #ffffff;\n    font-size: 3rem !important;\n  }\n\n  &__title {\n    font-size: 40px;\n    font-weight: 500;\n    color: #000000;\n    margin: 0 0 0.5rem 0;\n  }\n\n  &__button {\n    background: #FE5F55;\n    color: white;\n    border: none;\n    padding: 1.1rem 2.6rem;\n    font-size: 0.9rem;\n    font-weight: 400;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: transform 0.2s, box-shadow 0.2s;\n    margin-top: 2rem;\n    width: 80%;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 15px rgba(63, 120, 176, 0.3);\n    }\n\n    &--primary {\n      background-color: #FF6B6B; \n      color: white;\n\n      &:hover {\n        background-color: #e65a5a;\n      }\n    }\n  }\n\n  @media (max-width: $breakpoint-md) {\n    &__content {\n      width: 90%;\n      max-width: 420px;\n      padding: 3.5rem 1rem 2.5rem 1rem;\n    }\n\n    &__title {\n      font-size: 28px;\n    }\n\n    &__subtitle {\n      font-size: 18px;\n      color: #000000;\n    }\n\n    &__button {\n      width: 93%;\n    }\n\n    &__icon-wrapper {\n      width: 65px;\n      height: 65px;\n\n    }\n  }\n\n  &__error {\n    color: #d32f2f; \n    font-size: 0.9rem;\n    margin-top: 1rem;\n    text-align: center;\n  }\n}\n\n\n\n.confirmation-modal .confirmation-modal__subtitle {\n  font-size: 24px;\n  color: #000000;\n  margin: 0 0 2rem 0;\n  font-weight: 400;\n  line-height: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"confirmation-modal__backdrop": `ConfirmationModal_confirmation-modal__backdrop__pe3QY`,
	"confirmation-modal__content": `ConfirmationModal_confirmation-modal__content__eUjSf`,
	"confirmation-modal__icon-wrapper": `ConfirmationModal_confirmation-modal__icon-wrapper__v5oG2`,
	"confirmation-modal__icon": `ConfirmationModal_confirmation-modal__icon__ZFRWF`,
	"confirmation-modal__title": `ConfirmationModal_confirmation-modal__title__NVZIK`,
	"confirmation-modal__button": `ConfirmationModal_confirmation-modal__button__ZEIzk`,
	"confirmation-modal__button--primary": `ConfirmationModal_confirmation-modal__button--primary__WIoNg`,
	"confirmation-modal__subtitle": `ConfirmationModal_confirmation-modal__subtitle__9TKML`,
	"confirmation-modal__error": `ConfirmationModal_confirmation-modal__error__iGOf9`,
	"confirmation-modal": `ConfirmationModal_confirmation-modal__eZdsE`
};
export default ___CSS_LOADER_EXPORT___;
